function configure(Highcharts) {
    Highcharts.Tooltip.prototype.defaultHeaderFormatter = function (tooltip) {
        return tooltip.tooltipFooterHeaderFormatter(this);
    };
    Highcharts.Tooltip.prototype.defaultFooterFormatter = function (tooltip) {
        return tooltip.tooltipFooterHeaderFormatter(this, true);
    };
    Highcharts.Tooltip.prototype.defaultFormatter = function (tooltip) {
        var items = this.points || Highcharts.splat(this);
        var options = tooltip.options;
        var headerFormatter = options.headerFormatter || tooltip.defaultHeaderFormatter;
        var footerFormatter = options.footerFormatter || tooltip.defaultFooterFormatter;
        // Build the header
        var s = [headerFormatter.call(items[0], tooltip)];
        // build the values
        s = s.concat(tooltip.bodyFormatter(items));
        // footer
        s.push(footerFormatter.call(items[0], tooltip));
        return s;
    };
}
export default configure;
